import src from "IMAGE";
export default { src, width: 212, height: 116, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAARklEQVR42o2KsQ6AIAwFMfpaGhASo241sjHw/98HDKyEmy65M2aBDfb82N8FElNzPdi9Ozj0NgYld2VI+EmikvUPmoxhSgWtSQKZ1TPq4AAAAABJRU5ErkJggg=="};
